module.exports = __webpack_public_path__ + "static/media/folder.c77e4858.svg";